[
  {
    "dia": "14M",
    "mupi": 3,
    "hora": "10h25min",
    "numero": 9,
    "titulo": "Ortopedia Pré-Cirúrgica na Fenda Lábio-Palatina: Casos Clínicos",
    "autor": "Catarina Machado"
  },
  {
    "dia": "14M",
    "mupi": 3,
    "hora": "10h32min",
    "numero": 10,
    "titulo": "Tratamento ortodôntico de tração do canino maxilar incluso: Caso Clínico",
    "autor": "Daniela Basto"
  },
  {
    "dia": "14M",
    "mupi": 3,
    "hora": "10h39min",
    "numero": 11,
    "titulo": "Granuloma piogénico: revisão da literatura a propósito de um caso clínico",
    "autor": "Joana Barbosa Magalhães"
  },
  {
    "dia": "14M",
    "mupi": 3,
    "hora": "10h46min",
    "numero": 12,
    "titulo": "Avulsão dentária em jovem: do diagnóstico ao prognóstico",
    "autor": "Andreia Esteves Fernandes"
  },
  {
    "dia": "14M",
    "mupi": 3,
    "hora": "10h53min",
    "numero": 39,
    "titulo": "From Revitalization to Apexification: A 14-year journey of an immature permanent tooth",
    "autor": "Beatriz P. Santos"
  }
]